import {
  REPORTS_INVOICES_PAGE_REQUEST,
  REPORTS_INVOICES_LIST_INVOICE_REQUEST,
  REPORTS_INVOICES_SET_LIST_INVOICE,
  REPORTS_INVOICES_CHANGE_DATE,
  REPORTS_INVOICES_CHANGE_OUTLET,
  REPORTS_INVOICES_CHANGE_STATUS,
  REPORTS_INVOICES_RECEIPT_REQUEST,
  REPORTS_INVOICES_SET_RECEIPT,
  REPORTS_INVOICES_HIDE_RECEIPT,
  REPORTS_INVOICES_RESEND_EMAIL,
  REPORTS_INVOICES_CHANGE_FORM_RECORD_PAYMENT,
  REPORTS_INVOICES_RECORD_PAYMENT_REQUEST,
  REPORTS_INVOICES_SHOW_RECORD_PAYMENT_MODAL,
  REPORTS_INVOICES_HIDE_RECORD_PAYMENT_MODAL,
  REPORTS_INVOICES_PRINT_RECEIPT_PDF,
  REPORTS_INVOICES_SHOW_CANCEL_INVOICE_MODAL,
  REPORTS_INVOICES_HIDE_CANCEL_INVOICE_MODAL,
  REPORTS_INVOICES_ISSUE_REFUND_REQUEST,
  REPORTS_INVOICES_SHOW_OLD_CANCEL_INVOICE_MODAL,
  REPORTS_INVOICES_HIDE_OLD_CANCEL_INVOICE_MODAL,
  REPORTS_INVOICES_ISSUE_OLD_REFUND_REQUEST,
  REPORTS_INVOICES_EXPORT_INVOICES,
  REPORTS_INVOICES_SET_OUTLETS,
  REPORTS_INVOICES_ON_CLICK_RECORD_PAYMENT,
  REPORTS_INVOICES_ON_CANCEL_RECORD_PAYMENT,
  REPORTS_INVOICES_SET_CURRENT_PAGE,
  REPORTS_INVOICES_SET_TOTAL_PAGE,
} from './constants';

export function invoicesPageRequest() {
  return { type: REPORTS_INVOICES_PAGE_REQUEST, payload: {} };
}

export function listInvoiceRequest(query, previousInvoices?) {
  return {
    type: REPORTS_INVOICES_LIST_INVOICE_REQUEST,
    payload: { query, previousInvoices },
  };
}

export function setListInvoice(invoices) {
  return { type: REPORTS_INVOICES_SET_LIST_INVOICE, payload: { invoices } };
}

/**
 *
 * @param {Date} startDate new start
 * @param {Date} endDate new end
 * @param {array} statuses
 * @param {string} keyword
 * @return {{type, payload: {startDate: *, endDate: *, statuses: *}}}
 */
export function changeDateInvoices(startDate, endDate, statuses, keyword) {
  return {
    type: REPORTS_INVOICES_CHANGE_DATE,
    payload: { startDate, endDate, statuses, keyword },
  };
}

export function changeOutletInvoices(
  outletIds,
  startDate,
  endDate,
  statuses,
  keyword
) {
  return {
    type: REPORTS_INVOICES_CHANGE_OUTLET,
    payload: { outletIds, startDate, endDate, statuses, keyword },
  };
}

export function changeStatusInvoices(statuses, startDate, endDate, keyword) {
  return {
    type: REPORTS_INVOICES_CHANGE_STATUS,
    payload: { statuses, startDate, endDate, keyword },
  };
}

export function receiptInvoicesRequest(
  id: number,
  uuid: string,
  isMobile: boolean
) {
  return {
    type: REPORTS_INVOICES_RECEIPT_REQUEST,
    payload: { id, uuid, isMobile },
  };
}

export function setReceiptInvoices(receiptInvoices) {
  return { type: REPORTS_INVOICES_SET_RECEIPT, payload: { receiptInvoices } };
}

export function hideReceiptInvoice(isMobile?) {
  return { type: REPORTS_INVOICES_HIDE_RECEIPT, payload: { isMobile } };
}

export function changeFormRecordPayment(recordPayment) {
  return {
    type: REPORTS_INVOICES_CHANGE_FORM_RECORD_PAYMENT,
    payload: { recordPayment },
  };
}

export function recordPaymentRequest(data) {
  return { type: REPORTS_INVOICES_RECORD_PAYMENT_REQUEST, payload: { data } };
}

export function resendEmail(invoiceId: number, invoiceUuid: string) {
  return {
    type: REPORTS_INVOICES_RESEND_EMAIL,
    payload: { invoiceId, invoiceUuid },
  };
}

export function showRecordPaymentModal() {
  return { type: REPORTS_INVOICES_SHOW_RECORD_PAYMENT_MODAL, payload: {} };
}

export function hideRecordPaymentModal() {
  return { type: REPORTS_INVOICES_HIDE_RECORD_PAYMENT_MODAL, payload: {} };
}

export function printReceiptInvoicePdf(invoiceId: number, invoiceUuid: string) {
  return {
    type: REPORTS_INVOICES_PRINT_RECEIPT_PDF,
    payload: { invoiceId, invoiceUuid },
  };
}

export function showCancelInvoiceModal() {
  return { type: REPORTS_INVOICES_SHOW_CANCEL_INVOICE_MODAL, payload: {} };
}

export function hideCancelInvoiceModal() {
  return { type: REPORTS_INVOICES_HIDE_CANCEL_INVOICE_MODAL, payload: {} };
}

export function issueRefundRequest(data) {
  return { type: REPORTS_INVOICES_ISSUE_REFUND_REQUEST, payload: { data } };
}

export function showOldCancelInvoiceModal() {
  return { type: REPORTS_INVOICES_SHOW_OLD_CANCEL_INVOICE_MODAL, payload: {} };
}

export function hideOldCancelInvoiceModal() {
  return { type: REPORTS_INVOICES_HIDE_OLD_CANCEL_INVOICE_MODAL, payload: {} };
}

export function issueOldRefundRequest(data) {
  return { type: REPORTS_INVOICES_ISSUE_OLD_REFUND_REQUEST, payload: { data } };
}

export function exportInvoices(query, filename, outletId) {
  return {
    type: REPORTS_INVOICES_EXPORT_INVOICES,
    payload: { query, filename, outletId },
  };
}

export function setOutlets(outlets) {
  return { type: REPORTS_INVOICES_SET_OUTLETS, payload: { outlets } };
}

export function onClickRecordPayment() {
  return { type: REPORTS_INVOICES_ON_CLICK_RECORD_PAYMENT, payload: {} };
}

export function onCancelRecordPayment() {
  return { type: REPORTS_INVOICES_ON_CANCEL_RECORD_PAYMENT, payload: {} };
}

export function setCurrentPage(currentPage) {
  return { type: REPORTS_INVOICES_SET_CURRENT_PAGE, payload: { currentPage } };
}

export function setTotalPage(totalPage) {
  return { type: REPORTS_INVOICES_SET_TOTAL_PAGE, payload: { totalPage } };
}
